import { getQaSelector } from '../../../../utils/common'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantDocumentChecklist } from './ApplicantDocumentChecklist'
import { ApplicantIdentityWidget } from './ApplicantIdentityWidget'
import { ApplicantMatchingWidget } from './ApplicantMatchingWidget'
import { QA_NAME_APPLICANT_PROFILE_OVERVIEW } from './RentalPortalApplicantProfileTabOverview.constants'
import { getHasApplicantDocumentChecklist } from './RentalPortalApplicantProfileTabOverview.utils'

import * as styles from './RentalPortalApplicantProfileTabOverview.module.css'

function RentalPortalApplicantProfileTabOverview() {
  const { applicantData } = useApplicantProfileContext()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_PROFILE_OVERVIEW })}
      className={styles.RentalPortalApplicantProfileTabOverview}
    >
      <ApplicantIdentityWidget />
      <ApplicantMatchingWidget />
      {getHasApplicantDocumentChecklist(applicantData) ? (
        <ApplicantDocumentChecklist />
      ) : null}
    </div>
  )
}

export default RentalPortalApplicantProfileTabOverview
